<template>
    <div class="card">
        <div class="card-header">eigene Preisänderung und Lager-Artikel</div>
        <div class="card-body">
            <label for="price-change-since">
                eigene Preisänderung (Monate):
            </label>
            <b-form-input
                id="price-change-since"
                v-model.number="priceChangeSince"
                type="number"
                placeholder="Anzahl Monate"
                min="0"
                @keypress="onlyAllowIntegers($event)"
            ></b-form-input>
            <Info title="Eigene Preisänderung:">
                Filtert alle Artikel, die in den letzten x Monaten bepreist wurden.
                <br />
                0 Monate schalten den Filter aus.
            </Info>
            <br />
            <b-form-checkbox
                id="toggle-articles-not-on-storage"
                v-model="articlesNotOnStorage"
                :value="true"
                :unchecked-value="false"
            >
                Nicht-Lagerartikel anzeigen
            </b-form-checkbox>
        </div>
    </div>
</template>

<script>
import Info from "@/components/widgets/Info";
export default {
    name: "PricecCangeService",
    components: { Info },
    computed: {
        articlesNotOnStorage: {
            get() {
                return this.$store.state.filter.articlesNotOnStorage;
            },
            set(value) {
                this.$store.commit("setArticlesNotOnStorage", value);
            }
        },
        priceChangeSince: {
            get() {
                return this.$store.state.filter.priceChangeSince;
            },
            set(value) {
                this.$store.commit("setPriceChangeSince", parseInt(value) || 0);
            }
        }
    }
};
</script>

<style scoped>
.card-body > * {
    margin: 2px;
}
.card-body > label {
    margin-top: 8px;
    margin-bottom: 0px;
}
</style>
